import type { ReactNode } from 'react';

import { Card } from '@/shared/ui/atoms/Card';
import './Kpi.styl';

export type KpiTone = 'up' | 'down' | 'flat' | 'risk';

type Props = {
  value: ReactNode;
  unit?: string;
  label: string;
  sub?: ReactNode;
  tone?: KpiTone;
  risk?: boolean;
  children?: ReactNode;
};

export function Kpi({ value, unit, label, sub, tone = 'flat', risk = false, children }: Props) {
  return (
    <Card {...(risk ? { tone: 'risk' as const } : {})} className="a-kpi">
      <div className={risk ? 'a-kpi__value u-mono a-kpi__value--risk' : 'a-kpi__value u-mono'}>
        {value}
        {unit ? <span className="a-kpi__unit"> {unit}</span> : null}
      </div>
      <div className="a-kpi__label">{label}</div>
      {sub ? <div className={`a-kpi__sub a-kpi__sub--${tone}`}>{sub}</div> : null}
      {children}
    </Card>
  );
}
